// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';


$(window).on('load resize', function() {
    if ($(window).width() <= 992) {
        let i = 0;
        // Assign individual classes to pagination and bullets for each instance of slider
        //Pagination Bullets
        const paginationBulletsCard = document.querySelectorAll('.swiper-card-pagination');
        for (i = 0; i < paginationBulletsCard.length; i++) {
            paginationBulletsCard[i].classList.add('swiper-card-pagination-' + i);
        }
        //Pagination Arrow Next
        const paginationNextCard = document.querySelectorAll('.swiper-card-next');
        for (i = 0; i < paginationNextCard.length; i++) {
            paginationNextCard[i].classList.add('swiper-card-next-' + i);
        }
        //Pagination Arrow Prev
        const paginationPrevCard = document.querySelectorAll('.swiper-card-prev');
        for (i = 0; i < paginationPrevCard.length; i++) {
            paginationPrevCard[i].classList.add('swiper-card-prev-' + i);
        }

        //Swiper JS
        const cardSlider = document.querySelectorAll('.card-slider');
        for( i=0; i< cardSlider.length; i++ ) {
            cardSlider[i].classList.add('card-slider-' + i);
            var sliderCard = new Swiper('.card-slider-' + i, {
                a11y: {
                    enabled: true
                },
                centeredSlides: false,
                breakpointBase: 'window',
                slidesPerView:1.15,
                spaceBetween: 30,
                slideClass:'swiper-card-slide',

                navigation: {
                    nextEl: '.swiper-card-next-' + i + '',
                    prevEl: '.swiper-card-prev-' + i + '',
                },

                pagination: {
                    el: '.swiper-card-pagination-' + i + '',
                    clickable: true,
                },
                // on: {
                //     slideChange: function () {
                //         if (this.isEnd) {
                //             $(this.slides[this.slides.length - 1]).closest('.card-slider').css('padding-right', '20px');
                //         } else {
                //             $(this.slides[this.slides.length - 1]).closest('.card-slider').css('padding-right', '0px');
                //         }
                //     }
                // }
            });

        }
    }
});
